import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useI18n } from '@/contexts/I18nContext';

export function Pagination({ total, pageSize, currentPage, onPageChange }) {
  const { t } = useI18n();
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;

  const from = (currentPage - 1) * pageSize + 1;
  const to = Math.min(currentPage * pageSize, total);

  return (
    <div className="flex items-center justify-between pt-4" data-testid="pagination">
      <p className="text-sm text-muted-foreground">
        {t('pagination.showing')} {from} {t('pagination.to')} {to} {t('pagination.of')} {total}
      </p>
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="sm"
          disabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
          data-testid="pagination-prev"
        >
          <ChevronLeft className="w-4 h-4 mr-1" />
          {t('pagination.prev')}
        </Button>
        {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
          let page;
          if (totalPages <= 5) {
            page = i + 1;
          } else if (currentPage <= 3) {
            page = i + 1;
          } else if (currentPage >= totalPages - 2) {
            page = totalPages - 4 + i;
          } else {
            page = currentPage - 2 + i;
          }
          return (
            <Button
              key={page}
              variant={page === currentPage ? 'default' : 'outline'}
              size="sm"
              className={page === currentPage ? 'bg-[#007FFF] hover:bg-[#0066CC]' : ''}
              onClick={() => onPageChange(page)}
              data-testid={`pagination-page-${page}`}
            >
              {page}
            </Button>
          );
        })}
        <Button
          variant="outline"
          size="sm"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          data-testid="pagination-next"
        >
          {t('pagination.next')}
          <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </div>
  );
}
